import { LEVELS, CONFIGURATION_KEYS } from 'constants/enums'

export function getRegistrationAgeKeys(awardId) {
  let keys = {
    min: '',
    max: ''
  }

  switch (awardId) {
    case LEVELS.BRONZE.id:
      keys = {
        min: CONFIGURATION_KEYS.participantBronzeRegistrationMin.id,
        max: CONFIGURATION_KEYS.participantBronzeRegistrationMax.id
      }
      break
    case LEVELS.SILVER.id:
      keys = {
        min: CONFIGURATION_KEYS.participantSilverRegistrationMin.id,
        max: CONFIGURATION_KEYS.participantSilverRegistrationMax.id
      }
      break
    case LEVELS.GOLD.id:
      keys = {
        min: CONFIGURATION_KEYS.participantGoldRegistrationMin.id,
        max: CONFIGURATION_KEYS.participantGoldRegistrationMax.id
      }
      break
    default:
  }

  return keys
}
